import { column } from "@podtrac/common/grid";
import { CopyButton } from "../../components/copy-button";
import styles from "../link-report.module.scss";
import { EditPromotionButton } from "./edit-promotion-button";
import { Elide } from "./elide";

// TODO - row selection

export const placementColumn = (enableSelect, enableEdit) =>
    column.group({
        header: "URL",
        columns: [
            column.accessor("alias", {
                id: "URL",
                header: "Total",
                cell: PlacementCell,
                meta: { enableSelect, enableEdit },
            }),
        ],
    });

function PlacementCell({
    getValue,
    column: {
        columnDef: {
            meta: { enableSelect, enableEdit },
        },
    },
    row: {
        original: { canEdit, promotionID, placementID },
    },
}) {
    const alias = getValue();
    const displayUrl = `https://link.podtrac.com/${alias}`;
    return (
        <div className={styles.flex}>
            {/* TODO: row selection */}
            {enableSelect ? "" : null}
            <Elide title={displayUrl}>{displayUrl}</Elide>
            <CopyButton noborder text={displayUrl} />
            {enableEdit && canEdit ? (
                <EditPromotionButton
                    promotionID={promotionID}
                    placementID={placementID}
                />
            ) : null}
        </div>
    );
}
